module.exports = __webpack_public_path__ + "img/hostFaqBanner_20231212_2.ec10170d.jpg";